import { Injectable } from '@angular/core';
import { Observable, catchError, finalize, map, throwError } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { LoadingService } from './loading.service';
import { environment } from 'src/environments/environment';
import { RequestService } from './request.service';

export interface IfingerPrint {
  finger_index: number;
  finger_template: string;
  finger_featureset: string;
  finger_photos: any[];
  quality: string;
  is_active: boolean;
  side: SIDE.LEFT | SIDE.RIGHT;
  description?: string;
}

export enum SIDE {
  LEFT = "LEFT",
  RIGHT = "RIGHT",
}

@Injectable({
  providedIn: 'root'
})
export class FingerprintLocalApiService {

  constructor(
    private http: HttpClient,
    private loadingService: LoadingService,
    private requestService: RequestService
  ) { }

  enrollment(): Observable<{ fingerprints: IfingerPrint[] }> {
    const url = environment.local_fingerprint_api_url + '/fingerprint/enrollment';
    return this.http.get<{ fingerprints: IfingerPrint[] }>(url).pipe(
      map(res => {
        return {
          fingerprints: res.fingerprints.filter(f => f).map((f: any) => {
            return {
              finger_photos: [f.fingerprint_image_base64],
              finger_featureset: f.featureset,
              finger_template: f.template,
              finger_index: f.index,
              is_active: f.is_active,
              side: f.index > 5 ? SIDE.LEFT : SIDE.RIGHT,
              quality: f.quality,
            };
          })
        }
      }),
      catchError((error) => {
        return throwError(() => ({ message: error.message }));
      }),
      finalize(() => {
        this.loadingService.setLoading(false);
      })
    );
  }

  verifyFingerprint(templates: Array<string>) {
    return this.requestService.postLocalJSON("/fingerprint/verify", {
      data: {
        fingerprints: templates
      },
      option: {
        is_loading: true
      }
    });
  }
}
